import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';

import useSettings from '../../hooks/useSettings';
import useUserData from '../../hooks/useUserData';
import { alertLocalizedMsg, executeStored } from '../../Utils';
import BooleanField from '../../fields/BooleanField';
import SimpleTextField from '../../fields/SimpleTextField';
import ResponsiveDialog from '../../dialogs/ResponsiveDialog';
import { type MiddlewhereFilter } from '../FilterItemManager';
import Form from '../../Form';

interface FilterSaveDialogProps {
	module: string;
	isOpen: boolean;
	closeDialog: () => void;
	currentFilters: MiddlewhereFilter[];
}

/** Dialog used to save user's filters */
export default function FilterSaveDialog({ module, isOpen, closeDialog, currentFilters }: FilterSaveDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();

	const [fiterName, setFilterName] = React.useState('');
	const [isPublic, setIsPublic] = React.useState(false);

	function saveFilter() {
		executeStored({
			action: 'st_sys_filters_saved_add',
			dispatch,
			data: {
				filt_name: fiterName,
				filt_module: module,
				filt_user_uid: userData.user_uid,
				filt_is_public: isPublic,
				filt_json: currentFilters
			},
			successHandler: response => {
				dispatch(alertLocalizedMsg(t, 'ALERT_ADD_SUCCESS', 'success'));
				setFilterName('');
				closeDialog();
			}
		});
	}

	return (
		<ResponsiveDialog
			open={isOpen}
			onClose={closeDialog}
			maxWidth="xs"
			title={t('DIALOG_TITLE_FILTER_SAVE')}
			content={
				<Form id="filterSaveDialog" onSubmit={saveFilter}>
					<SimpleTextField
						name="filt_name"
						label={t('DIALOG_FILTER_NAME')}
						value={fiterName}
						isEdit
						sendChange={(_name, value) => setFilterName(value ?? '')}
						required
						validationError={t('ERROR_TEXT_REQUIRED')}
					/>

					<BooleanField
						name="filt_is_public"
						label={t('DIALOG_FILTER_PUBLIC')}
						value={isPublic}
						isEdit
						sendChange={(_name, value) => setIsPublic(value ?? false)}
					/>
				</Form>
			}
			actions={
				<>
					<Button onClick={closeDialog}>{t('DIALOG_ACTION_BACK')}</Button>
					<Button type="submit" form="filterSaveDialog" color="secondary">
						{t('DIALOG_ACTION_SAVE')}
					</Button>
				</>
			}
		/>
	);
}
